module.exports = __webpack_public_path__ + "img/Frame_06.fc1d493a.png";